<template>
  <div class="ds-role-item">
    <div class="ds-role-item-header">
      <div class="text-lg">Роль: {{ name }}</div>
    </div>

    <div class="ds-role-groups">
      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.general" @click="toggleGroup('general')">
          <span>Общий доступ</span><span>{{ expandedGroups.general ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.general" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_access_main"
            label="Доступ в основную систему"
            name="can_access_main"
          ></role-check>
        </div>
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_access_all_departments"
            label="Доступ ко всем поразделениям"
            name="can_access_all_departments"
          ></role-check>
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.mobile" @click="toggleGroup('mobile')">
          <span>Мобильное приложение</span><span>{{ expandedGroups.mobile ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.mobile" class="ds-role-group-content">
          <role-check
            v-model="currentSettings.can_access_mobile"
            label="Доступ в мобильное приложение"
            name="can_access_mobile"
          ></role-check>
          <role-check
            v-model="currentSettings.can_access_schedule_in_mobile"
            label="Показывать раздел «График»"
            name="can_access_schedule_in_mobile"
          ></role-check>
          <role-check
            v-model="currentSettings.can_access_shift_exchange_in_mobile"
            label="Показывать раздел «Биржа смен»"
            name="can_access_shift_exchange_in_mobile"
          ></role-check>
          <role-check
            v-model="currentSettings.can_access_messages_in_mobile"
            label="Показывать раздел «Сообщения»"
            name="can_access_messages_in_mobile"
          ></role-check>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.schedule" @click="toggleGroup('schedule')">
          <span>График и табель</span><span>{{ expandedGroups.schedule ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.schedule" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_view_schedule_and_timesheet"
            label="Просмотр графика и табеля"
            name="can_view_schedule_and_timesheet"
          ></role-check>
          <role-check
            v-model="currentSettings.can_create_schedule"
            label="Создание графика"
            name="can_create_schedule"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_day_type"
            label="Редактирование типа дня"
            name="can_edit_day_type"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_day_state_duration"
            label="Продолжительность для КО"
            name="can_edit_day_state_duration"
          ></role-check>
          <role-check
            v-model="currentSettings.can_permanently_edit_day_state_duration"
            label="Безусловное редактирование продолжительности КО"
            name="can_permanently_edit_day_state_duration"
            :disabled="!currentSettings.can_edit_day_state_duration"
          ></role-check>
          <role-check
            v-model="currentSettings.can_approve_schedule"
            label="Утверждение графика"
            name="can_approve_schedule"
          ></role-check>
        </div>
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_upload_schedule"
            label="Загрузка графика"
            name="can_upload_schedule"
          ></role-check>
          <role-check
            v-model="currentSettings.can_download_schedule"
            label="Выгрузка графика"
            name="can_download_schedule"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_shift_schedule"
            label="Редактирование графика смен"
            name="can_edit_shift_schedule"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_timesheet"
            label="Редактирование табеля"
            name="can_edit_timesheet"
          ></role-check>
          <role-check
            v-model="currentSettings.extended_cell_info"
            label="Расширенная информация ячейки"
            name="extended_cell_info"
          ></role-check>
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.fact" @click="toggleGroup('fact')">
          <span>Фактическое время и контроль</span><span>{{ expandedGroups.fact ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.fact" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <!-- <role-check
            v-model="currentSettings.can_manage_urv"
            label="Управление УРВ"
            name="can_manage_urv"
          ></role-check>
          <role-check
            v-model="currentSettings.can_manage_qr_code"
            label="Управление QR-кодами"
            name="can_manage_qr_code"
          ></role-check> -->
          <role-check
            v-model="currentSettings.can_create_check_points"
            label="Создание контрольных точек"
            name="can_create_check_points"
          ></role-check>
        </div>

        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_edit_fact_time"
            label="Редактирование фактического времени"
            name="can_edit_fact_time"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_past_fact_time"
            label="Редактирование фактического времени в прошлом"
            name="can_edit_past_fact_time"
          ></role-check>
          <base-input
            class="ds-role-days-input"
            v-model="currentSettings.days_in_past_to_manage_fact_time"
            v-if="currentSettings.can_edit_past_fact_time"
            >Дней в прошлом для редактирования факта</base-input
          >
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.history" @click="toggleGroup('history')">
          <span>История</span><span>{{ expandedGroups.history ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.history" class="ds-role-group-content">
        <role-check
          v-model="currentSettings.can_view_shift_history"
          label="Просмотр истории смен"
          name="can_view_shift_history"
        ></role-check>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.reports" @click="toggleGroup('reports')">
          <span>Отчёты и выгрузки</span><span>{{ expandedGroups.reports ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.reports" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_download_timesheet"
            label="Выгрузка табеля"
            name="can_download_timesheet"
          ></role-check>
          <role-check
            v-model="currentSettings.can_download_fraud_report"
            label="Выгрузка отчета Фрод"
            name="can_download_fraud_report"
          ></role-check>
          <role-check
            v-model="currentSettings.can_download_manual_marks_report"
            label="Скачать отчёт об отметках"
            name="can_download_manual_marks_report"
          ></role-check>
          <role-check
            v-model="currentSettings.can_download_outsource_report"
            label="Выгрузка отчета Аутсорс"
            name="can_download_outsource_report"
          ></role-check>
        </div>
        <div class="flex-1">
          <role-check
            v-model="currentSettings"
            label="Отчет по рабочему времени"
            name="can_download_work_time_report"
          ></role-check>
          <role-check
            v-model="currentSettings.can_download_discipline_report"
            label="Выгрузка отчета Дисциплина"
            name="can_download_discipline_report"
          ></role-check>
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.employees" @click="toggleGroup('employees')">
          <span>Сотрудники</span><span>{{ expandedGroups.employees ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.employees" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_view_user_list"
            label="Просмотр сотрудников"
            name="can_view_user_list"
          ></role-check>
          <role-check
            v-model="currentSettings.can_create_user"
            label="Создание сотрудника"
            name="can_create_user"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_user_main_info"
            label="Редактирование основной информации сотрудника"
            name="can_edit_user_main_info"
          ></role-check>
          <role-check
            v-model="currentSettings.can_change_smart_checkin_possible"
            label="Изменение настроек СмартОтметки"
            name="can_change_smart_checkin_possible"
          ></role-check>
          <role-check
            v-model="currentSettings.can_reset_user_password"
            label="Восстановление пароля сотрудника"
            name="can_reset_user_password"
          ></role-check>
        </div>
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_view_user_archive"
            label="Просмотр архива сотрудников"
            name="can_view_user_archive"
          ></role-check>
          <role-check
            v-model="currentSettings.can_delete_user"
            label="Удаление сотрудника"
            name="can_delete_user"
          ></role-check>
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.employment" @click="toggleGroup('employment')">
          <span>Трудоустройство</span><span>{{ expandedGroups.employment ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.employment" class="ds-role-group-content">
        <role-check
          v-model="currentSettings.can_create_employment"
          label="Создание трудоустройства"
          name="can_create_employment"
        ></role-check>
        <role-check
          v-model="currentSettings.can_edit_employment"
          label="Редактирование трудоустройства"
          name="can_edit_employment"
        ></role-check>
        <role-check
          v-model="currentSettings.can_delete_employment"
          label="Удаление трудоустройства"
          name="can_delete_employment"
        ></role-check>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.vacancies" @click="toggleGroup('vacancies')">
          <span>Вакансии</span><span>{{ expandedGroups.vacancies ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.vacancies" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_view_shift_exchange"
            label="Просмотр биржи смен"
            name="can_view_shift_exchange"
          ></role-check>
          <role-check
            v-model="currentSettings.can_create_vacancy_exchange"
            label="Создание обмена вакансиями / сменами"
            name="can_create_vacancy_exchange"
          ></role-check>

          <role-check
            v-model="currentSettings.can_view_vacancies"
            label="Просмотр вакансий"
            name="can_view_vacancies"
          ></role-check>
        </div>
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_view_vacancy_requests"
            label="Просмотр запросов на вакансии"
            name="can_view_vacancy_requests"
          ></role-check>
          <role-check
            v-model="currentSettings.can_create_vacancy_request"
            label="Создание запроса на вакансию"
            name="can_create_vacancy_request"
          ></role-check>
          <role-check
            v-model="currentSettings.can_confirm_vacancy_request"
            label="Подтверждение запроса на вакансию"
            name="can_confirm_vacancy_request"
          ></role-check>
          <role-check
            v-model="currentSettings.can_confirm_user_for_vacancy"
            label="Подтверждение сотрудника на вакансию"
            name="can_confirm_user_for_vacancy"
          ></role-check>
        </div>
        </div>
      </section>

      <section class="ds-role-group">
        <button type="button" class="ds-role-group-trigger" :aria-expanded="expandedGroups.system" @click="toggleGroup('system')">
          <span>Справочники и настройки системы</span><span>{{ expandedGroups.system ? '−' : '+' }}</span>
        </button>
        <div v-show="expandedGroups.system" class="ds-role-group-content ds-settings-permission-grid">
        <div class="flex-1">
          <role-check
            v-model="currentSettings.can_manage_shift_exchange"
            label="Управление биржей смен"
            name="can_manage_shift_exchange"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_account_settings"
            label="Редактирование настроек аккаунта"
            name="can_edit_account_settings"
          ></role-check>
          <role-check
            v-model="currentSettings.can_create_department"
            label="Создание подразделений"
            name="can_create_department"
          ></role-check>
          <role-check
            v-model="currentSettings.can_edit_position"
            label="Редактирование должностей"
            name="can_edit_position"
          ></role-check>
          <!-- <role-check
            v-model="currentSettings.can_create_positions"
            label="Создание должностей"
            name="can_create_positions"
          ></role-check> -->
        </div>
        <div class="flex-1">
           <role-check
            v-model="currentSettings.can_edit_roles"
            label="Редактирование ролей"
            name="can_edit_roles"
          ></role-check>
          <role-check
            v-model="currentSettings.can_manage_analytics"
            label="Управление аналитикой"
            name="can_manage_analytics"
          ></role-check>
        </div>
        </div>
      </section>
    </div>

    <div class="ds-role-actions">
      <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
      <btn class="ml-3" type="secondary" @click="cancel">Отмена</btn>
    </div>
    <div v-if="saveError" class="ds-role-save-error" role="alert">
      Не удалось сохранить роль. <button type="button" @click="save">Повторить</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import RoleCheck from "./RoleCheck.vue";
import { useSettingsStore } from "@/stores/settingsStore";
import { Role } from "@/types";

const settingsStore = useSettingsStore();

// Пропсы компонента
const props = defineProps<{
  role: Role;
}>();

const normalizeRoleSettings = (role: Role): Role => ({
  ...role,
  can_access_schedule_in_mobile: role.can_access_schedule_in_mobile ?? true,
  can_access_shift_exchange_in_mobile: role.can_access_shift_exchange_in_mobile ?? true,
  can_access_messages_in_mobile: role.can_access_messages_in_mobile ?? true,
  can_change_smart_checkin_possible: role.can_change_smart_checkin_possible ?? false,
  can_reset_user_password: role.can_reset_user_password ?? false,
  can_download_manual_marks_report: role.can_download_manual_marks_report ?? false,
  can_permanently_edit_day_state_duration:
    role.can_edit_day_state_duration
      ? role.can_permanently_edit_day_state_duration ?? false
      : false,
});

// Реактивные данные
const originalSettings = ref<Role>(normalizeRoleSettings(props.role));
const currentSettings = ref<Role>(normalizeRoleSettings(props.role));
type RoleGroup = 'general' | 'mobile' | 'schedule' | 'fact' | 'history' | 'reports' | 'employees' | 'employment' | 'vacancies' | 'system'

const expandedGroups = ref<Record<RoleGroup, boolean>>({
  general: true,
  mobile: false,
  schedule: false,
  fact: false,
  history: false,
  reports: false,
  employees: false,
  employment: false,
  vacancies: false,
  system: false,
})

const toggleGroup = (group: RoleGroup) => {
  expandedGroups.value[group] = !expandedGroups.value[group]
}

// Вычисляемое свойство: есть ли несохранённые изменения
const hasUnsavedChanges = computed(() => {
  const keys = Object.keys(originalSettings.value) as Array<keyof Role>;
  return keys.some((key) => {
    const original = originalSettings.value[key];
    const current = currentSettings.value[key];

    // Для null/undefined используем строгое сравнение
    if (
      original === null ||
      original === undefined ||
      current === null ||
      current === undefined
    ) {
      return original !== current;
    }
    return current !== original;
  });
});
const isSaving = ref(false);
const saveError = ref(false);
// Кнопка задизейблена, когда нет изменений
const isDisabled = computed(() => !hasUnsavedChanges.value || isSaving.value);

// Имя роли
const name = ref(props.role.name);

// Сохранение изменений — отправляем только изменённые настройки
const save = async () => {
  isSaving.value = true;
  const changedSettings: any = {};
  const keys = Object.keys(originalSettings.value) as Array<keyof Role>;

  keys.forEach((key) => {
    if (currentSettings.value[key] !== originalSettings.value[key]) {
      changedSettings[key] = currentSettings.value[key];
    }
  });
  const error = await settingsStore.changeRole(props.role.id, changedSettings);
  isSaving.value = false;
  if (error) {
    saveError.value = true;
    return;
  }

  saveError.value = false;
  originalSettings.value = { ...currentSettings.value }; // обновляем оригинальные значения
};

// Отмена изменений — возвращаем оригинальные значения
const cancel = () => {
  currentSettings.value = { ...originalSettings.value };
};

// Наблюдаем за изменениями пропса role и обновляем внутренние состояния
watch(
  () => props.role,
  (newSettings) => {
    originalSettings.value = normalizeRoleSettings(newSettings);
    currentSettings.value = normalizeRoleSettings(newSettings);
  },
);

watch(
  () => currentSettings.value.can_edit_day_state_duration,
  () => {
    if (!currentSettings.value.can_edit_day_state_duration) {
      currentSettings.value.can_permanently_edit_day_state_duration = false;
    }
  },
);

watch(
  () => currentSettings.value.can_view_schedule_and_timesheet,
  () => {
    if (!currentSettings.value.can_view_schedule_and_timesheet) {
      currentSettings.value.can_create_schedule = false;
      currentSettings.value.can_edit_day_type = false;
      currentSettings.value.can_approve_schedule = false;
      currentSettings.value.can_upload_schedule = false;
      currentSettings.value.can_download_schedule = false;
      currentSettings.value.can_edit_shift_schedule = false;
      currentSettings.value.can_edit_timesheet = false;
    }
  },
);
</script>
